import { render } from "./SonMerchant.vue?vue&type=template&id=ae7f87a4&scoped=true"
import script from "./SonMerchant.vue?vue&type=script&lang=js"
export * from "./SonMerchant.vue?vue&type=script&lang=js"

import "./SonMerchant.vue?vue&type=style&index=0&id=ae7f87a4&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7f87a4"]])

export default __exports__